"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _modalActions = require("../../../../redux/actions/modalActions");
var _InterestAccountSettingsComponent = _interopRequireDefault(require("./InterestAccountSettingsComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var accountStatus = state.interestBearingAccounts.accountStatus;
  var enabled = accountStatus ? 'enabled' : 'disabled';
  var text = '';
  if (accountStatus === 'Pending') {
    text = accountStatus;
  } else {
    text = enabled;
  }
  return {
    enabled: enabled,
    accountStatus: accountStatus,
    text: text.toLowerCase()
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openEnableModal: function openEnableModal() {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.INTEREST_LENDING_ENABLE));
    },
    openDisableModal: function openDisableModal() {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.INTEREST_DISABLE));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_InterestAccountSettingsComponent["default"]);